import loadable from '@loadable/component'

export const Profile = loadable(() => import('./Profile'))
export type { ProfileProps } from './Profile'
